export enum TICKET {
  SEMESTER = 1,
  YEAR = 2,
  KLIMA = 3
}
